import { render } from "./DentiflowLogo.vue?vue&type=template&id=6b1b57a2&scoped=true"
import script from "./DentiflowLogo.vue?vue&type=script&lang=js"
export * from "./DentiflowLogo.vue?vue&type=script&lang=js"

import "./DentiflowLogo.vue?vue&type=style&index=0&id=6b1b57a2&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1b57a2"]])

export default __exports__